import * as BigBingoInternals from "../bigbingo-internals.ts";
import type {Conversion, PartialLearningTimeInfo} from "../types.ts";

export async function markConversion(
    conversion: Conversion | ReadonlyArray<Conversion>,
    learningTimeInfo: PartialLearningTimeInfo,
): Promise<Response | void> {
    const conversions = Array.isArray(conversion) ? conversion : [conversion];

    const response = await BigBingoInternals.markConversionsWithExtras(
        conversions,
        learningTimeInfo,
    );
    return response;
}
